/** Combobox para seleção de horário (HH:MM). Design responsivo, evita corte. */

const HORAS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTOS = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

function parseValue(val: string): { h: string; m: string } {
  const [h, m] = (val || '08:00').split(':');
  const hora = HORAS.includes(h) ? h : '08';
  const minVal = parseInt(m, 10);
  const idx = Number.isFinite(minVal) ? Math.min(11, Math.round(minVal / 5)) : 0;
  const minuto = MINUTOS[idx] ?? '00';
  return { h: hora, m: minuto };
}

interface TimeSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  size?: 'sm' | 'md';
}

export function TimeSelect({ value, onChange, className = '', size = 'md' }: TimeSelectProps) {
  const { h: hora, m: minuto } = parseValue(value);

  const handleHoraChange = (newH: string) => onChange(`${newH}:${minuto}`);
  const handleMinutoChange = (newM: string) => onChange(`${hora}:${newM}`);

  const sizeClass = size === 'sm' ? 'py-2 px-2 text-sm min-h-[36px]' : 'py-2.5 px-3 text-sm min-h-[40px]';

  return (
    <div className={`inline-flex items-center gap-1 rounded-lg border border-gray-200 bg-white min-w-[6.5rem] shrink-0 ${className}`}>
      <select
        value={hora}
        onChange={(e) => handleHoraChange(e.target.value)}
        className={`${sizeClass} border-0 bg-transparent focus:ring-2 focus:ring-orange-400 focus:outline-none cursor-pointer rounded-md`}
      >
        {HORAS.map((hr) => (
          <option key={hr} value={hr}>{hr}h</option>
        ))}
      </select>
      <span className="text-gray-500 font-medium text-sm">:</span>
      <select
        value={minuto}
        onChange={(e) => handleMinutoChange(e.target.value)}
        className={`${sizeClass} border-0 bg-transparent focus:ring-2 focus:ring-orange-400 focus:outline-none cursor-pointer rounded-md`}
      >
        {MINUTOS.map((min) => (
          <option key={min} value={min}>{min}</option>
        ))}
      </select>
    </div>
  );
}
